import GolfFormatter from 'utils/formatters/GolfFormatter';
import i18next from 'i18next';

export const ClubTypeFamilyType = ['Driver', 'Wood', 'Hybrid', 'Iron', 'Wedge', 'Putter'];

export const FlexTypeMapping = {
    REGULAR: 'flex.regular',
    STIFF: 'flex.stiff',
    EXTRA_STIFF: 'flex.extra.stiff',
    SENIOR: 'flex.senior',
    LADIES: 'flex.ladies',
    STIFF_REGULAR: 'flex.stiff.regular',
    REGULAR: 'flex.regular'
};

export const ClubTypeMapping = {
    '0': {
        shortName: 'unknown.abbrev',
        fullName: 'golf_club_type_unknown'
    },
    '1': {
        shortName: 'driver.abbrev',
        fullName: 'club.type.driver'
    },
    '2': {
        shortName: 'three.wood.abbrev',
        fullName: 'club.type.3.wood'
    },
    '3': {
        shortName: 'five.wood.abbrev',
        fullName: 'club.type.5.wood'
    },
    '4': {
        shortName: 'one.hybrid.abbrev',
        fullName: 'club.type.1.hybrid'
    },
    '5': {
        shortName: 'two.hybrid.abbrev',
        fullName: 'club.type.2.hybrid'
    },
    '6': {
        shortName: 'three.hybrid.abbrev',
        fullName: 'club.type.3.hybrid'
    },
    '7': {
        shortName: 'four.hybrid.abbrev',
        fullName: 'club.type.4.hybrid'
    },
    '8': {
        shortName: 'five.hybrid.abbrev',
        fullName: 'club.type.5.hybrid'
    },
    '9': {
        shortName: 'six.hybrid.abbrev',
        fullName: 'club.type.6.hybrid'
    },
    '10': {
        shortName: 'one.iron.abbrev',
        fullName: 'club.type.1.iron'
    },
    '11': {
        shortName: 'two.iron.abbrev',
        fullName: 'club.type.2.iron'
    },
    '12': {
        shortName: 'three.iron.abbrev',
        fullName: 'club.type.3.iron'
    },
    '13': {
        shortName: 'four.iron.abbrev',
        fullName: 'club.type.4.iron'
    },
    '14': {
        shortName: 'five.iron.abbrev',
        fullName: 'club.type.5.iron'
    },
    '15': {
        shortName: 'six.iron.abbrev',
        fullName: 'club.type.6.iron'
    },
    '16': {
        shortName: 'seven.iron.abbrev',
        fullName: 'club.type.7.iron'
    },
    '17': {
        shortName: 'eight.iron.abbrev',
        fullName: 'club.type.8.iron'
    },
    '18': {
        shortName: 'nine.iron.abbrev',
        fullName: 'club.type.9.iron'
    },
    '19': {
        shortName: 'pitching.wedge.abbrev',
        fullName: 'club.type.pitching.wedge'
    },
    '20': {
        shortName: 'gap.wedge.abbrev',
        fullName: 'club.type.gap.wedge'
    },
    '21': {
        shortName: 'sand.wedge.abbrev',
        fullName: 'club.type.sand.wedge'
    },
    '22': {
        shortName: 'lob.wedge.abbrev',
        fullName: 'club.type.lob.wedge'
    },
    '23': {
        shortName: 'putter.abbrev',
        fullName: 'putter'
    },
    '24': {
        shortName: 'two.wood.abbrev',
        fullName: 'club.type.2.wood'
    },
    '25': {
        shortName: 'four.wood.abbrev',
        fullName: 'club.type.4.wood'
    },
    '26': {
        shortName: 'seven.wood.abbrev',
        fullName: 'club.type.7.wood'
    },
    '27': {
        shortName: 'nine.wood.abbrev',
        fullName: 'club.type.9.wood'
    },
    '28': {
        shortName: 'eleven.wood.abbrev',
        fullName: 'club.type.11.wood'
    },
    '29': {
        shortName: 'thirteen.wood.abbrev',
        fullName: 'club.type.13.wood'
    },
    '30': {
        shortName: 'fifteen.wood.abbrev',
        fullName: 'club.type.15.wood'
    },
    '31': {
        shortName: 'seventeen.wood.abbrev',
        fullName: 'club.type.17.wood'
    },
    '32': {
        shortName: 'nineteen.wood.abbrev',
        fullName: 'club.type.19.wood'
    },
    '33': {
        shortName: 'twenty.one.wood.abbrev',
        fullName: 'club.type.21.wood'
    },
    '34': {
        shortName: 'twenty.three.wood.abbrev',
        fullName: 'club.type.23.wood'
    },
    '35': {
        shortName: 'twenty.five.wood.abbrev',
        fullName: 'club.type.25.wood'
    },
    '36': {
        shortName: 'seven.hybrid.abbrev',
        fullName: 'club.type.7.hybrid'
    },
    '37': {
        shortName: 'eight.hybrid.abbrev',
        fullName: 'club.type.8.hybrid'
    },
    '38': {
        shortName: 'nine.hybrid.abbrev',
        fullName: 'club.type.9.hybrid'
    },
    '39': {
        shortName: 'pitching.wedge.hybrid.abbrev',
        fullName: 'club.type.pitching.wedge.hybrid'
    },
    '40': {
        shortName: 'gap.wedge.hybrid.abbrev',
        fullName: 'club.type.gap.wedge.hybrid'
    },
    '41': {
        shortName: 'sand.wedge.hybrid.abbrev',
        fullName: 'club.type.sand.wedge.hybrid'
    },
    '42': {
        shortName: 'lob.wedge.hybrid.abbrev',
        fullName: 'club.type.lob.wedge.hybrid'
    }
};

export const getClubTypeString = function(clubTypeId) {
    if (clubTypeId === undefined || clubTypeId === null) {
        return ClubTypeMapping[0].shortName;
    }
    return ClubTypeMapping[clubTypeId.toString()].shortName;
};

export const getFullClubTypeString = (clubTypeId) => {
    if (clubTypeId === undefined || clubTypeId === null) {
        return ClubTypeMapping[0].fullName;
    }
    return ClubTypeMapping[clubTypeId.toString()].fullName;
};

export const getFlexTypeString = (flexTypeId) => {
    if (!flexTypeId) {
        return '';
    }
    return FlexTypeMapping[flexTypeId];
};

// Find all the activities this gear is set as default for
export const findGearDefaultActivities = (gear, defaultGears, activityTypes) => {
    let activities = [];

    for (let i = 0; i < defaultGears.length; i++) {
        if (defaultGears[i].uuid === gear.uuid && defaultGears[i].defaultGear === true) {
            // Find corresponding activity types
            activityTypes.map((item, idx) => {
                if (item.typeId === defaultGears[i].activityTypePk) {
                    activities.push({ ...item, uuid: defaultGears[i].uuid });
                }
            });
        }
    }

    return activities;
};

export const customSortClubs = (golfClubs, golfClubTypes, includeRetiredClubs) => {
    const isRetired = includeRetiredClubs ? includeRetiredClubs : false;

    // Find the family type depending on the club
    const getClubTypeByFamilyType = (familyType, golfClubs, golfClubTypes) => {
        if (!golfClubs) return [];

        const getClubType = (id, golfClubTypes) => {
            return golfClubTypes.find((clubType) => clubType.value === parseInt(id));
        };
        let list = [];

        if (golfClubTypes && golfClubs) {
            for (let c = 0; c < golfClubs.length; c++) {
                for (let i = 0; i < golfClubTypes.length; i++) {
                    if (
                        golfClubs[c].clubTypeId === golfClubTypes[i].value &&
                        golfClubTypes[i].name.indexOf(familyType) > -1 &&
                        golfClubs[c].retired === isRetired
                    ) {
                        list.push(golfClubs[c]);
                    }
                }
            }

            if (list) {
                //sort by loft angle
                list.sort((a, b) => {
                    //within each loft angle bracket, sort by nickname
                    const a_loft = getClubType(a.clubTypeId, golfClubTypes).loftAngle,
                        b_loft = getClubType(b.clubTypeId, golfClubTypes).loftAngle,
                        a_nickname = a.name || '',
                        b_nickname = b.name || '';

                    if (a_loft === b_loft) {
                        //both the same, sort by nickname
                        return a_nickname.localeCompare(b_nickname);
                    }

                    if (a_loft < b_loft) {
                        return -1;
                    }

                    if (a_loft > b_loft) {
                        return 1;
                    }
                    return 0;
                });
            }
        }

        return list;
    };

    //display of clubs order by clubType family (Driver, Wood Iron...etc) from smallest to biggest
    //then order by loft angle, then order by nickname
    let results = [];
    for (let c = 0; c < ClubTypeFamilyType.length; c++) {
        let listClub = getClubTypeByFamilyType(ClubTypeFamilyType[c], golfClubs, golfClubTypes);
        if (listClub) {
            for (var l = 0; l < listClub.length; l += 1) {
                if (listClub[l]) {
                    results.push(listClub[l]);
                }
            }
        }
    }
    return results;
};

export const getAverageDistanceFormatted = (club) => {
    // Club stats object has the average for the last 50 shots, the average at the root is lifetime.
    const averageDistance = club.clubStats ? club.clubStats.averageDistance : null;
    const format = averageDistance
        ? GolfFormatter.personalizeDistance(averageDistance) +
          ' ' +
          i18next.t(`units:${GolfFormatter.distanceUnitKey()}`)
        : '— ' + i18next.t(`units:${GolfFormatter.distanceUnitKey()}`);

    return format;
};

export const getMaxDistanceFormatted = (club) => {
    const maxLifetimeDistance = club.clubStats ? club.clubStats.maxLifetimeDistance : null;
    const format = maxLifetimeDistance
        ? GolfFormatter.personalizeDistance(maxLifetimeDistance) +
          ' ' +
          i18next.t(`units:${GolfFormatter.distanceUnitKey()}`)
        : '— ' + i18next.t(`units:${GolfFormatter.distanceUnitKey()}`);

    return format;
};

export const getLoftAngleData = (id, golfClubTypes, htmlEncodingDecoding) => {
    let found = '';

    const getLoftAngleDisplayValue = (clubType) => {
        if (!clubType.displayRange) {
            return clubType.loftAngle + '&deg;';
        }
        return clubType.displayRange;
    };

    found = golfClubTypes.find((item) => {
        return item.value === id;
    });
    //loft angle column in grid displays 'displays range' first, if null, then displays 'loft angle'
    if (found) {
        return htmlEncodingDecoding.htmlDecode(getLoftAngleDisplayValue(found));
    }
    return found;
};

export const sortGolfClubTypes = (a, b) => {
    let a_clubTypeFamilyIndex = ClubTypeFamilyType.findIndex((clubTypeFamilyName) => {
        return (
            a.value > 0 && a.name.indexOf(clubTypeFamilyName) > -1 // 0 is unknown club type and should be filtered out
        );
    });

    let b_clubTypeFamilyIndex = ClubTypeFamilyType.findIndex((clubTypeFamilyName) => {
        return (
            b.value > 0 && b.name.indexOf(clubTypeFamilyName) > -1 // 0 is unknown club type and should be filtered out
        );
    });

    if (a_clubTypeFamilyIndex !== b_clubTypeFamilyIndex) {
        return a_clubTypeFamilyIndex - b_clubTypeFamilyIndex;
    }

    let a_loft = a.loftAngle,
        b_loft = b.loftAngle;

    if (a_loft < b_loft) {
        return -1;
    }

    if (a_loft > b_loft) {
        return 1;
    }
    return 0;
};

/**
 *  Sort golf clubs so retired clubs are at the end of the list
 */
export const sortGolfClubs = (a, b) => {
    return a.retired === b.retired ? 0 : a.retired ? 1 : -1;
};

export const MaxClubTypeId = Object.keys(ClubTypeMapping).length - 1;
